<template>
  <div class="supplier-info">
    <div class="title">
      <i class="el-icon-s-home" style=" font-size: 30px;"></i>
      <span>{{ objitem.shopName }}</span>
      <span>{{ objitem.shopFollowsCount }}粉丝</span>
      <span>月销：{{ objitem.sales30 }}件</span>
      <span>复购率：{{ objitem.repurchase30 }}% </span>
      <span>售后率：{{ objitem.percent30 }}%</span>
    </div>
    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="100px" align="center" label="序号">
        </el-table-column>
        <el-table-column
          prop="logistic_business"
          align="center"
          label="商品主图"
        >
          <template slot-scope="scope">
            <el-image
              class="kv pointer"
              :src="scope.row.kv"
              :preview-src-list="[scope.row.kv]"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="title" align="center" label="商品名称">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.title) }}
          </template>
        </el-table-column>
        <el-table-column prop="grossWeight" align="center" label="毛重（斤）"
          ><template slot-scope="scope">
            {{ $empty.empty(scope.row.grossWeight) }}
          </template></el-table-column
        >
        <el-table-column prop="grossWeightPrice" align="center" label="毛单价">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.grossWeightPrice) }}
          </template>
        </el-table-column>
        <el-table-column prop="weight" align="center" label="净重（斤）">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.weight) }}
          </template>
        </el-table-column>
        <el-table-column prop="weightPrice" align="center" label="净单价">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.weightPrice) }}
          </template>
        </el-table-column>
        <el-table-column prop="price" align="center" label="开市价">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.price) }}
          </template>
        </el-table-column>
        <el-table-column prop="stock" align="center" label="库存数量">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.stock) }}
          </template>
        </el-table-column>
        <el-table-column prop="repurchase30" align="center" label="复购率">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.repurchase30) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="productFavoritesCount"
          align="center"
          label="收藏人数"
        >
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.productFavoritesCount) }}
          </template>
        </el-table-column>
        <el-table-column prop="state" align="center" label="商品状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 1">待审核</span>
            <span v-else-if="scope.row.state == 2">上架</span>
            <span v-else-if="scope.row.state == 3">下架</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "supplier-info",
  components: {},
  data() {
    return {
      //列表新建页面初始参数
      loading: true,

      from: {
        supplier_id: "",
        page: 1,
        pageSize: 10,
      },

      tableData: [],
      currentPage: 1,
      total: 0,
      objitem: "",
    };
  },
  computed: {},
  created() {
    this.from.supplier_id = this.$route.query.id;
    this.hqlist();
    this.hqinfo();
  },
  methods: {
    hqinfo() {
      this.$api.general
        .followsinfo({ supplier_id: this.$route.query.id })
        .then((res) => {
          console.log(res, "获取数据");
          this.objitem = res.data;
        });
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;

      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.currentPage = val;
      this.hqlist();
    },
    hqlist() {
      this.loading = true;

      this.$api.general.favoriteslist(this.from).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.supplier-info {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;

  .kv {
    width: 100px;
    height: 100px;
  }
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    
    span{
        font-size: 30px;
        margin-left: 20px;
    }

  }
  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
